<template>
  <div class="admin-dashboard">
    <PageHeader 
      pageName="Administration" 
      pageTitle="Administration" 
      pageSubtitle="Panneau de contrôle Super Admin"
    >
      <template #actions>
        <div class="header-actions-wrapper">
          <button class="back-btn-modern" @click="goBack">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            <span>Retour</span>
          </button>
        </div>
      </template>
    </PageHeader>

    <div class="dashboard-content">
      <!-- Global Stats Summary (Now at top of content) -->
      <div class="header-stats-modern content-stats">
        <div class="mini-stat-modern">
          <span class="ms-label">Comptes</span>
          <span class="ms-value">{{ globalStats.totalUsers }}</span>
        </div>
        <div class="ms-divider"></div>
        <div class="mini-stat-modern">
          <span class="ms-label">Agents Actifs</span>
          <span class="ms-value">{{ globalStats.activeChatbots || 0 }}</span>
        </div>
        <div class="ms-divider"></div>
        <div class="mini-stat-modern">
          <span class="ms-label">Comptes WA</span>
          <span class="ms-value">{{ globalStats.ownersWithWA || 0 }}</span>
        </div>
      </div>
      <!-- Notification -->
      <div v-if="notification.show" class="notification" :class="notification.type">
        {{ notification.message }}
      </div>

      <!-- TABS NAVIGATION -->
      <div class="tabs-container">
        <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'whatsapp' }"
            @click="activeTab = 'whatsapp'"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            Gestion WhatsApp
        </button>
        <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'ai' }"
            @click="activeTab = 'ai'"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"/>
                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0"/>
                <path d="M12 6v2m0 8v2m-6-6h2m8 0h2"/>
            </svg>
            Configuration IA
        </button>
        <button 
            class="tab-btn" 
            :class="{ active: activeTab === 'credits' }"
            @click="activeTab = 'credits'"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
            Monitoring Crédit
        </button>
      </div>

      <!-- Dev Dump Control -->
      <div v-if="isDev" class="dev-controls" style="margin-bottom: 1rem;">
          <button @click="showDump = !showDump" style="background: #ef4444; color: white; padding: 0.5rem; border-radius: 4px; border: none; cursor: pointer;">
              🕷️ DUMP OWNERS (DEV ONLY)
          </button>
          <div v-if="showDump" style="background: #1f2937; color: #10b981; padding: 1rem; margin-top: 0.5rem; border-radius: 8px; overflow: auto; max-height: 500px; font-family: monospace;">
              <pre>{{ JSON.stringify(owners, null, 2) }}</pre>
          </div>
      </div>

      <!-- TAB 1: WHATSAPP MANAGEMENT -->
      <section v-if="activeTab === 'whatsapp'" class="tab-panel users-section">
        <!-- Search and Filters -->
        <div class="dashboard-controls">
            <div class="controls-container">
                <div class="search-section">
                    <div class="search-input-wrapper">
                        <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="11" cy="11" r="8"></circle>
                            <path d="m21 21-4.35-4.35"></path>
                        </svg>
                        <input 
                            v-model="searchQuery" 
                            type="text" 
                            placeholder="Rechercher par nom, email, téléphone..." 
                            class="search-input"
                        >
                    </div>
                </div>
                <div class="filters-section">
                    <div class="filter-tabs">
                        <button 
                            class="filter-tab" 
                            :class="{ active: selectedFilter === 'all' }" 
                            @click="selectedFilter = 'all'"
                        >
                            <span class="tab-label">Tous</span>
                            <span class="tab-count">{{ owners.length }}</span>
                        </button>
                        <button 
                            class="filter-tab" 
                            :class="{ active: selectedFilter === 'with-whatsapp' }" 
                            @click="selectedFilter = 'with-whatsapp'"
                        >
                            <span class="tab-label">Avec WhatsApp</span>
                        </button>
                        <button 
                            class="filter-tab" 
                            :class="{ active: selectedFilter === 'pending' }" 
                            @click="selectedFilter = 'pending'"
                        >
                            <span class="tab-label">En attente</span>
                        </button>
                    </div>
                    
                    <div class="items-per-page">
                        <label for="itemsPerPage">Afficher :</label>
                        <select id="itemsPerPage" v-model="pagination.limit" @change="loadOwners" class="limit-select">
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                            <option :value="999999">Tous</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <!-- Users List -->
        <div class="users-container">
            <div v-if="loading" class="loading-container">
                <div class="loader"></div>
                <p>Chargement...</p>
            </div>

            <div v-else-if="filteredOwners.length === 0" class="empty-state">
                <p>Aucun utilisateur trouvé.</p>
            </div>

            <div v-else class="users-grid">
                <div v-for="owner in filteredOwners" :key="owner._id" class="user-card">
                    <!-- User Header -->
                    <!-- User Header Redesigned -->
                    <div class="user-header-modern">
                        <!-- Top Row: Identity & Actions -->
                        <div class="uh-top">
                            <div class="uh-identity">
                                <div class="uh-avatar">
                                    <img 
                                        :src="getAvatarUrl(owner)"
                                        :alt="owner.name"
                                        @error="handleAvatarError($event, owner)"
                                        class="uh-avatar-img"
                                    >
                                </div>
                                <div class="uh-text">
                                    <h3 class="uh-name">{{ owner.name }}</h3>
                                    <p class="uh-email">{{ owner.email }}</p>
                                </div>
                            </div>
                            <div class="uh-actions-top">
                                <button 
                                    class="icon-btn-modern" 
                                    title="Copier le lien de connexion automatique"
                                    @click="loginAsUser(owner)"
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Divider -->
                        <div class="uh-divider"></div>

                        <!-- Bottom Row: Stats 2x2 Grid -->
                        <div class="uh-grid">
                            <!-- Row 1: ID + Phone -->
                            <div class="uh-stat-row">
                                <div class="uh-stat-item">
                                    <span class="uh-label">User ID</span>
                                    <div class="uh-value clickable" @click.stop="copyToClipboard(owner._id, 'ID Utilisateur')">
                                        <code class="uh-code">{{ owner._id ? owner._id.substring(0, 8) : 'N/A' }}</code>
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="copy-icon"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                                    </div>
                                </div>
                                <div class="uh-stat-divider"></div>
                                <div class="uh-stat-item">
                                    <span class="uh-label">Téléphone</span>
                                    <div class="uh-value clickable" v-if="owner.tel" @click.stop="copyToClipboard(owner.tel, 'Téléphone')">
                                        {{ owner.tel }}
                                    </div>
                                    <div class="uh-value text-muted" v-else>N/A</div>
                                </div>
                            </div>

                            <!-- Row 2: Date + Plan -->
                            <div class="uh-stat-row">
                                <div class="uh-stat-item">
                                    <span class="uh-label">Inscrit le</span>
                                    <div class="uh-value uh-date">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                        {{ formatDate(getCreationDate(owner)) }}
                                    </div>
                                </div>
                                <div class="uh-stat-divider"></div>
                                <div class="uh-stat-item" @click.stop>
                                    <span class="uh-label">Plan</span>
                                    <div class="plan-selector-wrapper">
                                        <select 
                                            :value="owner.plan" 
                                            @change="updateOwnerPlan(owner, $event.target.value)"
                                            class="modern-select"
                                            :class="{'loading': owner.updatingPlan}"
                                            :disabled="owner.updatingPlan"
                                        >
                                            <option value="">Aucun</option>
                                            <option v-for="plan in plans" :key="plan.slug" :value="plan.slug">
                                                {{ plan.name }}
                                            </option>
                                        </select>
                                        <div v-if="owner.updatingPlan" class="spinner-mini"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Enterprise Price Input (Conditional) -->
                        <div v-if="owner.showEnterprisePriceInput" class="enterprise-config-panel" @click.stop>
                            <div class="ecp-header">
                                <span class="ecp-title">Configuration Enterprise</span>
                            </div>
                            <div class="ecp-body">
                                <div class="ecp-input-group">
                                    <label>Prix Mensuel (USD)</label>
                                    <input 
                                        type="number" 
                                        v-model.number="owner.customEnterprisePrice" 
                                        class="ecp-input" 
                                        placeholder="Ex: 500"
                                        min="0"
                                    >
                                </div>
                                <div class="ecp-actions">
                                    <button class="ecp-btn cancel" @click="cancelEnterprisePlan(owner)">Annuler</button>
                                    <button class="ecp-btn confirm" @click="confirmEnterprisePlan(owner)" :disabled="!owner.customEnterprisePrice">Valider</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Quota IA (superadmin) -->
                    <div class="aiq-panel" @click.stop>
                      <div class="aiq-head">
                        <span class="aiq-title">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                          Quota IA
                        </span>
                        <label class="aiq-switch">
                          <input type="checkbox" v-model="owner.ai_unlimited" @change="saveOwnerAiQuota(owner)"> Illimité
                        </label>
                      </div>
                      <div v-if="!owner.ai_unlimited" class="aiq-fields">
                        <div class="aiq-field">
                          <label>Moo (override)</label>
                          <input type="number" min="0" placeholder="plan" v-model.number="owner.aiQuotaMoo" class="aiq-input">
                        </div>
                        <div class="aiq-field">
                          <label>Griot (override)</label>
                          <input type="number" min="0" placeholder="plan" v-model.number="owner.aiQuotaGriot" class="aiq-input">
                        </div>
                        <button class="aiq-save" :disabled="owner.savingAiQuota" @click="saveOwnerAiQuota(owner)">Enregistrer</button>
                      </div>
                      <div class="aiq-agents">
                        <button class="aiq-agents-toggle" @click="toggleOwnerAgents(owner)">
                          {{ owner.showAgents ? '▾' : '▸' }} Quotas par agent
                        </button>
                        <div v-if="owner.showAgents" class="aiq-agents-list">
                          <div v-if="owner.loadingAgents" class="aiq-muted">Chargement…</div>
                          <div v-else-if="!owner.agents || !owner.agents.length" class="aiq-muted">Aucun agent</div>
                          <div v-else v-for="ag in owner.agents" :key="ag.idbot" class="aiq-agent-row">
                            <span class="aiq-agent-name">{{ ag.name }}</span>
                            <label class="aiq-agent-unl"><input type="checkbox" v-model="ag.unlimited"> ∞</label>
                            <input type="number" min="0" placeholder="Moo" v-model.number="ag.moo" :disabled="ag.unlimited" class="aiq-input sm">
                            <input type="number" min="0" placeholder="Griot" v-model.number="ag.griot" :disabled="ag.unlimited" class="aiq-input sm">
                            <button class="aiq-save sm" :disabled="ag.saving" @click="saveAgentAiQuota(owner, ag)">OK</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- WhatsApp Accounts Section -->
                    <div class="whatsapp-section">
                        <div class="section-header">
                            <div class="section-title">
                                <svg class="whatsapp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                                <h4>Comptes WhatsApp</h4>
                                <span class="count-badge">{{ owner.whatsappAccounts ? owner.whatsappAccounts.length : 0 }}</span>
                            </div>
                        </div>

                        <div v-if="!owner.whatsappAccounts || owner.whatsappAccounts.length === 0" class="empty-whatsapp">
                            <div class="empty-whatsapp-icon">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                            </div>
                            <p>Aucun compte WhatsApp configuré</p>
                        </div>

                        <div v-else class="whatsapp-accounts-grid">
                            <div v-for="account in owner.whatsappAccounts" :key="account._id" class="whatsapp-card">
                                <div class="whatsapp-card-header">
                                    <div class="account-identity">
                                        <div class="phone-number">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                            </svg> 
                                            {{ account.display_phone_number || account.phone_number_id }}
                                        </div>
                                        <div class="business-name">{{ account.verified_name || 'Sans nom' }}</div>
                                    </div>
                                    <div class="verification-status">
                                        <select 
                                            :value="account.code_verification_status" 
                                            @change="updateVerificationStatus(account, $event.target.value)"
                                            class="status-dropdown"
                                            :class="account.code_verification_status ? account.code_verification_status.toLowerCase() : ''"
                                        >
                                            <option value="PENDING">En attente</option>
                                            <option value="VERIFIED">Vérifié</option>
                                            <option value="EXPIRED">Expiré</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="whatsapp-card-body">
                                    <div class="account-metrics">
                                        <div class="metric">
                                            <span class="metric-label">Type</span>
                                            <span class="metric-value">{{ account.account_mode || 'N/A' }}</span>
                                        </div>
                                        <div class="metric">
                                            <span class="metric-label">Qualité</span>
                                            <span class="metric-value" :class="'quality-' + (account.quality_rating || 'unknown').toLowerCase()">
                                                {{ account.quality_rating || 'UNKNOWN' }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="account-ids">
                                        <div class="id-item">
                                            <span class="id-label">WABA</span>
                                            <span class="id-value">{{ account.whatsapp_business_account_id }}</span>
                                        </div>
                                        <div class="id-item">
                                            <span class="id-label">Business</span>
                                            <span class="id-value">{{ account.business_id }}</span>
                                        </div>
                                        <div class="id-item bot-id-row" v-if="account.idbot">
                                            <span class="id-label">Bot ID</span>
                                            <span class="id-value clickable-text" @click.stop="copyToClipboard(account.idbot, 'ID Bot')" title="Copier l'ID Bot">{{ account.idbot }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
             <!-- Pagination -->
             <div class="pagination-container" v-if="pagination.totalPages > 1">
                 <button 
                     class="load-more-btn"
                     :disabled="pagination.page <= 1"
                     @click="changePage(pagination.page - 1)"
                 >
                     Précédent
                 </button>
                 <span class="pagination-info">Page {{ pagination.page }} / {{ pagination.totalPages }}</span>
                 <button 
                     class="load-more-btn"
                     :disabled="pagination.page >= pagination.totalPages"
                     @click="changePage(pagination.page + 1)"
                 >
                     Suivant
                 </button>
             </div>

        </div>
      </section>

      <!-- TAB 2: AI CONFIGURATION -->
      <section v-if="activeTab === 'ai'" class="tab-panel ai-config-section">
        <div class="config-header-wrapper">
             <div class="header-icon">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"/>
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0"/>
                    <path d="M12 6v2m0 8v2m-6-6h2m8 0h2"/>
                 </svg>
             </div>
             <div>
                <h2 class="section-title no-margin">Paramètres Globaux IA</h2>
                <p class="section-subtitle">Gérez le modèle par défaut et les limites d'utilisation pour tous les agents.</p>
             </div>
        </div>

        <!-- Quotas IA de base par formule (Moo / Griot) -->
        <div class="config-card quota-base-card">
          <div class="quota-card-head">
            <h3 class="column-title no-border">Quotas IA de base par formule</h3>
            <p class="config-help">
              Budget de crédits IA <strong>mensuel</strong> accordé par chaque formule (Moo et Griot séparément).
              <code>-1</code> = illimité. Surchargeable par compte ou par agent. À ne pas confondre avec le
              « Messages / jour » plus bas (limite anti-abus, pas un crédit).
            </p>
          </div>
          <div class="plan-quota-list">
            <div class="plan-quota-row" v-for="plan in plans" :key="plan.slug">
              <div class="pq-name">
                <span class="pq-plan">{{ plan.name }}</span>
                <span class="pq-price" v-if="plan.price_usd > 0">{{ plan.price_usd }} USD/mois</span>
                <span class="pq-price" v-else>Sur devis</span>
              </div>
              <div class="pq-field">
                <label class="pq-label">Moo</label>
                <div class="input-wrapper">
                  <input type="number" v-model.number="plan.ai_quota_moo" class="config-input pq-input" placeholder="0">
                  <span class="input-unit">créd./mois</span>
                </div>
              </div>
              <div class="pq-field">
                <label class="pq-label">Griot</label>
                <div class="input-wrapper">
                  <input type="number" v-model.number="plan.ai_quota_griot" class="config-input pq-input" placeholder="0">
                  <span class="input-unit">créd./mois</span>
                </div>
              </div>
              <button class="pq-save" :disabled="plan.savingQuota" @click="savePlanQuota(plan)">
                <span v-if="plan.savingQuota" class="spinner-sm"></span>
                <span v-else>Enregistrer</span>
              </button>
            </div>
          </div>
        </div>

        <div class="config-card">
          <div class="config-grid">
            <!-- COL 1: MODEL & PERFORMANCE -->
            <div class="config-column">
                <h3 class="column-title">Modèle & Performance</h3>
                
                <!-- Model Selection -->
                <div class="config-item">
                    <label class="config-label">
                        <svg class="label-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                            <rect x="9" y="9" width="6" height="6"></rect>
                            <path d="M9 1v3m6-3v3M9 20v3m6-3v3M20 9h3m-3 6h3M1 9h3m-3 6h3"></path>
                        </svg>
                        Modèle IA (Claude)
                    </label>
                    <div class="select-wrapper">
                        <select v-model="aiConfig.model" class="config-select">
                        <option v-for="model in claudeModels" :key="model.value" :value="model.value">
                            {{ model.label }} {{ model.isDefault ? '(Recommandé)' : '' }}
                        </option>
                        </select>
                        <div class="select-arrow">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M6 9l6 6 6-6"/>
                        </svg>
                        </div>
                    </div>
                    <p class="config-help">Ce modèle sera appliqué par défaut aux nouveaux agents.</p>
                </div>

                <!-- Context Limit -->
                <div class="config-item">
                    <label class="config-label">
                        <svg class="label-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                             <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                             <polyline points="14 2 14 8 20 8"></polyline>
                             <line x1="16" y1="13" x2="8" y2="13"></line>
                             <line x1="16" y1="17" x2="8" y2="17"></line>
                             <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                        Limite de Contexte
                    </label>
                    <div class="input-wrapper">
                        <input type="number" v-model.number="aiConfig.contextLimit" class="config-input" min="1" placeholder="Ex: 10">
                        <span class="input-unit">messages</span>
                    </div>
                    <p class="config-help">Nombre de messages passés conservés en mémoire pour la conversation.</p>
                </div>
            </div>

            <!-- COL 2: USAGE & LIMITS -->
            <div class="config-column">
                <h3 class="column-title">Limites d'Utilisation</h3>

                 <!-- Daily Messages Limit -->
                <div class="config-item">
                    <label class="config-label">
                        <svg class="label-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        Messages / jour (par utilisateur)
                    </label>
                    <div class="input-wrapper">
                        <input type="number" v-model.number="aiConfig.dailyLimit" class="config-input" min="1" placeholder="Ex: 50">
                        <span class="input-unit">msg / 24h</span>
                    </div>
                    <p class="config-help">Nombre max de messages qu'un utilisateur final peut envoyer à un bot par 24h (anti-abus). Ce n'est <strong>pas</strong> un crédit Moo/Griot.</p>
                </div>
                
                <!-- Future Item Placeholder (e.g., Temperature) -->
                 <div class="config-info-box">
                    <div class="info-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                    </div>
                    <p>Les modifications s'appliquent immédiatement à tous les agents configurés sur "Global Default".</p>
                </div>

            </div>
          </div>

          <div class="config-footer">
            <button class="save-config-btn" @click="saveAiConfig" :disabled="savingConfig">
              <span v-if="savingConfig" class="spinner-sm"></span>
              <svg v-else class="btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                  <polyline points="17 21 17 13 7 13 7 21"></polyline>
                  <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              {{ savingConfig ? 'Sauvegarde...' : 'Enregistrer la Configuration' }}
            </button>
          </div>
        </div>
      </section>

      <!-- TAB 3: CREDITS MONITORING - MODERN DESIGN -->
      <section v-if="activeTab === 'credits'" class="tab-panel credits-section-v2">
          
          <!-- Top Bar with Month Selector -->
          <div class="credits-top-bar">
              <div class="credits-greeting">
                  <span class="greeting-emoji">💳</span>
                  <div>
                      <h2>Surveillance des Crédits</h2>
                      <p>Suivi en temps réel de votre consommation API</p>
                  </div>
              </div>
              <div class="credits-controls">
                  <input type="month" v-model="creditsMonth" @change="loadCreditsData" class="month-picker">
                  <button @click="showCreditsDump = !showCreditsDump" class="refresh-btn" :class="{ 'active': showCreditsDump }" title="Dump Data">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                  </button>
                  <button @click="loadCreditsData" class="refresh-btn" title="Rafraîchir">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 4v6h-6"/><path d="M1 20v-6h6"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/><path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>
                  </button>
              </div>
          </div>

          <div v-if="loadingCredits" class="credits-loading">
              <div class="credits-loader"></div>
              <p>Chargement des statistiques...</p>
          </div>

          <div v-else-if="creditsData" class="credits-content-v2">
              
              <!-- Hero Section with Total Budget -->
              <div class="credits-hero">
                  <div class="hero-main">
                      <span class="hero-label">Budget Restant</span>
                      <div class="hero-amount">
                          <span class="currency">$</span>{{ formatSimpleCurrency(creditsData.dashboard.global_budget.remaining_usd) }}
                      </div>
                      <div class="hero-comparison">
                          <span :class="getBudgetStatusClass(creditsData.dashboard.global_budget.usage_percent)">
                              {{ getBudgetStatusText(creditsData.dashboard.global_budget.usage_percent) }}
                          </span>
                          sur ${{ formatSimpleCurrency(creditsData.dashboard.global_budget.initial_usd) }} de budget initial
                      </div>
                  </div>
              </div>

              <!-- Stats Cards Row -->
              <div class="credits-stats-row">
                  <div class="credit-stat-card">
                      <div class="csc-header">
                          <span class="csc-label">Consommé</span>
                          <span class="csc-icon consumed">↓</span>
                      </div>
                      <div class="csc-value">${{ formatSimpleCurrency(creditsData.dashboard.global_budget.consumed_usd) }}</div>
                      <div class="csc-bar">
                          <div class="csc-bar-fill consumed" :style="{ width: Math.min(creditsData.dashboard.global_budget.usage_percent, 100) + '%' }"></div>
                      </div>
                      <div class="csc-footer">{{ creditsData.dashboard.global_budget.usage_percent }}% du budget</div>
                  </div>

                  <div class="credit-stat-card">
                      <div class="csc-header">
                          <span class="csc-label">Tokens Utilisés</span>
                          <span class="csc-icon tokens">⚡</span>
                      </div>
                      <div class="csc-value">{{ formatNumber(creditsData.dashboard.tokens.total) }}</div>
                      <div class="csc-bar dual">
                          <div class="csc-bar-fill input" :style="{ width: getTokenPercent('input') + '%' }"></div>
                          <div class="csc-bar-fill output" :style="{ width: getTokenPercent('output') + '%' }"></div>
                      </div>
                      <div class="csc-footer">
                          <span class="token-legend input">● In: {{ formatNumber(creditsData.dashboard.tokens.total_input) }}</span>
                          <span class="token-legend output">● Out: {{ formatNumber(creditsData.dashboard.tokens.total_output) }}</span>
                      </div>
                  </div>

                   <div class="credit-stat-card">
                      <div class="csc-header">
                          <span class="csc-label">Requêtes API</span>
                          <span class="csc-icon requests">📊</span>
                      </div>
                      <div class="csc-value">{{ formatNumber(creditsData.dashboard.total_requests) }}</div>
                      <div class="csc-meta">Ce mois-ci</div>
                  </div>
              </div>

              <!-- Main Dashboard Grid -->
              <div class="credits-main-grid">
                  
                  <!-- Left Column: Health + Config -->
                  <div class="credits-col-left">
                      
                      <!-- Budget Health Card with Donut -->
                      <div class="health-card">
                          <div class="health-header">
                              <h3>Santé du Budget</h3>
                              <span :class="['health-badge', getBudgetHealthClass(creditsData.dashboard.global_budget.usage_percent)]">
                                  {{ getBudgetHealthLabel(creditsData.dashboard.global_budget.usage_percent) }}
                              </span>
                          </div>
                          <div class="health-content">
                              <div class="donut-container">
                                  <svg viewBox="0 0 36 36" class="donut-chart">
                                      <circle class="donut-bg" cx="18" cy="18" r="15.91549431" fill="transparent" stroke="#e5e7eb" stroke-width="3"></circle>
                                      <circle class="donut-segment" cx="18" cy="18" r="15.91549431" fill="transparent" 
                                          :stroke="getDonutColor(creditsData.dashboard.global_budget.usage_percent)" 
                                          stroke-width="3" 
                                          :stroke-dasharray="getDonutDasharray(100 - creditsData.dashboard.global_budget.usage_percent)"
                                          stroke-dashoffset="25"
                                          stroke-linecap="round"></circle>
                                  </svg>
                                  <div class="donut-center">
                                      <span class="donut-percent">{{ (100 - creditsData.dashboard.global_budget.usage_percent).toFixed(0) }}%</span>
                                      <span class="donut-label">Restant</span>
                                  </div>
                              </div>
                              <div class="health-details">
                                  <div class="health-detail-row">
                                      <span class="hdr-label">Budget Initial</span>
                                      <span class="hdr-value">${{ formatSimpleCurrency(creditsData.dashboard.global_budget.initial_usd) }}</span>
                                  </div>
                                  <div class="health-detail-row">
                                      <span class="hdr-label">Consommé</span>
                                      <span class="hdr-value consumed">${{ formatSimpleCurrency(creditsData.dashboard.global_budget.consumed_usd) }}</span>
                                  </div>
                                  <div class="health-detail-row">
                                      <span class="hdr-label">Restant</span>
                                      <span class="hdr-value remaining">${{ formatSimpleCurrency(creditsData.dashboard.global_budget.remaining_usd) }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <!-- Cost Breakdown -->
                      <div class="breakdown-card">
                          <h3>Répartition des Coûts</h3>
                          <div class="breakdown-bars">
                              <div class="bb-item">
                                  <div class="bb-row">
                                      <span class="bb-label">Coût Input</span>
                                      <span class="bb-value">${{ formatSimpleCurrency(creditsData.dashboard.cost_breakdown.input_cost) }}</span>
                                  </div>
                                  <div class="bb-bar"><div class="bb-fill input" :style="{ width: getCostPercent('input') + '%' }"></div></div>
                              </div>
                              <div class="bb-item">
                                  <div class="bb-row">
                                      <span class="bb-label">Coût Output</span>
                                      <span class="bb-value">${{ formatSimpleCurrency(creditsData.dashboard.cost_breakdown.output_cost) }}</span>
                                  </div>
                                  <div class="bb-bar"><div class="bb-fill output" :style="{ width: getCostPercent('output') + '%' }"></div></div>
                              </div>
                          </div>
                          <div class="breakdown-total">
                              <span>Total</span>
                              <span class="bt-value">${{ formatSimpleCurrency(creditsData.dashboard.cost_breakdown.total_cost) }}</span>
                          </div>
                      </div>

                      <!-- Budget Config -->
                      <div class="config-card-v2">
                          <h3>Configuration</h3>
                          <div class="config-form-v2">
                              <div class="cfg-group">
                                  <label>Budget Global</label>
                                  <div class="cfg-input-wrapper">
                                      <span class="cfg-prefix">$</span>
                                      <input type="number" v-model.number="budgetForm.budget_usd" class="cfg-input">
                                  </div>
                              </div>
                              <div class="cfg-group">
                                  <label>Seuils d'alerte</label>
                                  <div class="cfg-thresholds">
                                      <div class="cfg-threshold" v-for="(threshold, idx) in budgetForm.alert_thresholds" :key="idx">
                                          <input type="number" v-model.number="budgetForm.alert_thresholds[idx]" class="cfg-threshold-input">
                                          <span class="cfg-threshold-suffix">%</span>
                                      </div>
                                  </div>
                              </div>
                              <div class="cfg-actions">
                                  <button @click="updateBudget" class="cfg-btn primary" :disabled="updatingBudget">
                                      {{ updatingBudget ? 'Mise à jour...' : 'Enregistrer' }}
                                  </button>
                                  <button @click="testWebhook" class="cfg-btn secondary">Test Webhook</button>
                              </div>
                          </div>
                      </div>
                  </div>

                  <!-- Right Column: Agents List -->
                  <div class="credits-col-right">
                      <div class="agents-card">
                          <div class="agents-header">
                              <h3>Consommation par Agent</h3>
                              <span class="agents-count">{{ creditsData.dashboard.top_consumers.length }} agent(s)</span>
                          </div>
                          
                          <div v-if="creditsData.dashboard.top_consumers.length === 0" class="agents-empty">
                              <div class="ae-icon">📭</div>
                              <p>Aucune consommation enregistrée ce mois-ci</p>
                              <span class="ae-hint">Les agents apparaîtront ici lorsqu'ils consommeront des crédits</span>
                          </div>

                          <div v-else class="agents-list">
                              <div class="agent-list-header">
                                  <span>#</span>
                                  <span>Agent</span>
                                  <span>Modèle</span>
                                  <span class="text-right">Req.</span>
                                  <span class="text-right">Tokens</span>
                                  <span class="text-right">Coût</span>
                              </div>
                              <div v-for="consumer in creditsData.dashboard.top_consumers" :key="consumer.chatbot_id" class="agent-item-row">
                                  <div class="ai-rank">#{{ consumer.rank }}</div>
                                  <div class="ai-info-cell">
                                      <span class="ai-name">{{ consumer.chatbot_name || 'Agent Inconnu' }}</span>
                                      <span class="ai-id">{{ consumer.chatbot_id }}</span>
                                  </div>
                                  <div class="ai-model-cell">
                                      <span class="model-badge" :title="(consumer.models_used || []).join(', ')">{{ formatModels(consumer.models_used) }}</span>
                                  </div>
                                  <div class="ai-stat-cell text-right">{{ formatNumber(consumer.requests) }}</div>
                                  <div class="ai-stat-cell text-right">
                                      <div>{{ formatNumber(consumer.tokens?.total || 0) }}</div>
                                      <div class="sub-stat">{{ consumer.percent_of_total }}%</div>
                                  </div>
                                   <div class="ai-cost-cell text-right">
                                      <span class="aic-value">${{ formatSimpleCurrency(consumer.cost_usd) }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <!-- Alerts Section -->
                      <div class="alerts-card" v-if="creditsData.dashboard.alerts && creditsData.dashboard.alerts.length > 0">
                          <h3>⚠️ Alertes</h3>
                          <div class="alerts-list">
                              <div v-for="(alert, idx) in creditsData.dashboard.alerts" :key="idx" class="alert-item">
                                  {{ alert }}
                              </div>
                          </div>
                      </div>

                      <!-- DEBUG SECTION (TOGGLEABLE) -->
                      <div class="card-box" v-if="showCreditsDump" style="margin-top: 2rem; background: #1e1e1e; border-color: #333;">
                          <h3 style="color: #fff;">DEBUG DATA (SERVER RESPONSE)</h3>
                          <pre style="color: #4ade80; font-family: monospace; font-size: 0.8rem; overflow-x: auto;">{{ JSON.stringify(creditsData, null, 2) }}</pre>
                      </div>
                  </div>
              </div>

          </div>
      </section>

    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import AdminService from '@/services/adminService'
import { encryptUserData } from '@/utils/crypto'
import CryptoJS from 'crypto-js'
import { consoleLog, consoleError } from '@/utils/logger'
import { isDevelopment } from '@/config'
import PageHeader from '@/components/PageHeader.vue'

export default {
  name: 'AdminDashboard',
  components: {
    PageHeader
  },
  setup() {
    const router = useRouter()
    
    // UI STATE
    const activeTab = ref('whatsapp')
    const loading = ref(true)
    const savingConfig = ref(false)
    
    // CREDITS
    const creditsData = ref(null)
    const loadingCredits = ref(false)
    const creditsMonth = ref(new Date().toISOString().slice(0, 7)) // YYYY-MM
    const budgetForm = reactive({
        budget_usd: 25,
        alert_thresholds: [50, 80, 95]
    })
    const updatingBudget = ref(false)

    const notification = reactive({ show: false, type: 'success', message: '' })

    // DATA STATE
    const owners = ref([])
    const searchQuery = ref('')
    const selectedFilter = ref('all')
    const plans = ref([])
    
    // GLOBAL STATS
    const globalStats = ref({
        totalUsers: 0,
        totalChatbots: 0,
        activeChatbots: 0,
        totalWhatsAppAccounts: 0,
        ownersWithWA: 0,
        pendingVerifications: 0
    })

    // AI CONFIG
    const aiConfig = reactive({
        model: 'claude-3-7-sonnet-20250219',
        contextLimit: 10,
        dailyLimit: 50
    })

    const claudeModels = [
        { value: 'claude-3-7-sonnet-20250219', label: 'Claude 3.7 Sonnet', isDefault: true },
        { value: 'claude-opus-4-5-20251101', label: 'Claude Opus 4.5' },
        { value: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5' },
        { value: 'claude-sonnet-4-5-20250929', label: 'Claude Sonnet 4.5' },
        { value: 'claude-opus-4-1-20250805', label: 'Claude Opus 4.1' },
        { value: 'claude-opus-4-20250514', label: 'Claude Opus 4' },
        { value: 'claude-sonnet-4-20250514', label: 'Claude Sonnet 4' },
        { value: 'claude-3-5-haiku-20241022', label: 'Claude 3.5 Haiku' },
        { value: 'claude-3-haiku-20240307', label: 'Claude 3 Haiku' },
        { value: 'deepseek-v4-flash', label: 'DeepSeek V4 Flash' },
        { value: 'deepseek-v4-pro', label: 'DeepSeek V4 Pro' },
    ]
    
    const pagination = reactive({
      page: 1, limit: 100, total: 0, totalPages: 0
    })

    // COMPUTED
    const filteredOwners = computed(() => {
      let filtered = owners.value
      
      if (searchQuery.value.trim()) {
        const query = searchQuery.value.toLowerCase()
        filtered = filtered.filter(owner => {
          const matchesOwner = 
            (owner.name && owner.name.toLowerCase().includes(query)) ||
            (owner.email && owner.email.toLowerCase().includes(query)) ||
            (owner.tel && owner.tel.includes(query))
          
          const matchesWhatsApp = owner.whatsappAccounts?.some(account => 
            (account.display_phone_number && account.display_phone_number.includes(query)) ||
            (account.verified_name && account.verified_name.toLowerCase().includes(query))
          )
          
          return matchesOwner || matchesWhatsApp
        })
      }
      
      switch (selectedFilter.value) {
        case 'with-whatsapp':
          filtered = filtered.filter(owner => owner.whatsappAccounts && owner.whatsappAccounts.length > 0)
          break
        case 'pending':
          filtered = filtered.filter(owner => owner.whatsappAccounts?.some(a => a.code_verification_status === 'PENDING'))
          break
      }
      
      return filtered
    })

    // METHODS
    const showNotification = (message, type = 'success') => {
      notification.show = true; notification.type = type; notification.message = message
      setTimeout(() => { notification.show = false }, 5000)
    }

    const loadDashboardData = async () => {
        try {
            loading.value = true
            const stats = await AdminService.getGlobalStats()
            if(stats) globalStats.value = stats

            const config = await AdminService.getAdminConfig('global_ai')
            if(config) {
                if(config.model) aiConfig.model = config.model
                if(config.contextLimit) aiConfig.contextLimit = config.contextLimit
                if(config.dailyLimit) aiConfig.dailyLimit = config.dailyLimit
                if(config.contextLimit) aiConfig.contextLimit = config.contextLimit
                if(config.dailyLimit) aiConfig.dailyLimit = config.dailyLimit
            }

            // Load credits data initially too
            loadCreditsData()

            await loadOwners()
            
            // Load Plans
            try {
                const plansData = await AdminService.getPlans()
                if (plansData && plansData.plans) {
                    plans.value = plansData.plans
                }
            } catch (e) {
                consoleError('Error loading plans:', e)
            }

        } catch (error) {
            consoleError('Error loading dashboard:', error)
            showNotification('Erreur de chargement des données', 'error')
        } finally {
            loading.value = false
        }
    }

    const loadOwners = async () => {
         const response = await AdminService.getAllOwnersWithAccounts({
          page: pagination.page,
          limit: pagination.limit
        })
        owners.value = response.owners || []
        pagination.total = response.pagination?.total || 0
        pagination.totalPages = response.pagination?.totalPages || 0
    }

    const saveAiConfig = async () => {
        try {
            savingConfig.value = true
            await AdminService.updateAdminConfig('global_ai', aiConfig)
            showNotification('Configuration IA sauvegardée avec succès')
        } catch(error) {
             consoleError('Error saving config:', error)
             showNotification('Erreur de sauvegarde', 'error')
        } finally {
            savingConfig.value = false
        }
    }

    const handleImageError = (event) => { event.target.style.display = 'none' }
    
    const getInitials = (name) => {
      if (!name) return '??'
      return name.split(' ').map(w => w.charAt(0)).join('').toUpperCase().substring(0, 2)
    }

    const loginAsUser = async (owner) => {
        try {
           if (!owner._id) return
           // JWT Generation logic (same as before)
            const secretKey = 'Grandneuydegeur'
            const header = { alg: 'HS256', typ: 'JWT' }
            const now = Math.floor(Date.now() / 1000)
            const payload = {
                _id: owner._id,
                name: owner.name,
                email: owner.email,
                profile_picture: owner.profile_picture || 'https://placehold.co/250',
                accessToken: owner.accessToken || '',
                provenance: 'admin-login',
                tel: owner.tel || '',
                userType: owner.userType || 'provider',
                iat: now,
                exp: now + (48 * 60 * 60)
            }
            
            const base64url = (str) => CryptoJS.enc.Base64.stringify(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
            const encodedHeader = base64url(CryptoJS.enc.Utf8.parse(JSON.stringify(header)))
            const encodedPayload = base64url(CryptoJS.enc.Utf8.parse(JSON.stringify(payload)))
            const signature = CryptoJS.HmacSHA256(encodedHeader + '.' + encodedPayload, secretKey)
            const jwt = encodedHeader + '.' + encodedPayload + '.' + base64url(signature)

            const userData = {
                data: {
                    id: owner._id,
                    name: owner.name,
                    email: owner.email,
                    tel: owner.tel || '',
                    profile_picture: owner.profile_picture || 'https://placehold.co/250',
                    provenance: 'admin-login',
                    token: jwt
                }
            }
            
            const encryptedToken = encryptUserData(userData)
            const loginUrl = `${window.location.origin}/dashboard/auto-login/${encryptedToken}`
            
            await navigator.clipboard.writeText(loginUrl)
            showNotification(`Lien copié ! Vous pouvez vous connecter en tant que ${owner.name}`)

        } catch (error) {
            consoleError('Login error', error)
            showNotification('Erreur lors de la génération du lien', 'error')
        }
    }

    const isPlaceholderAvatar = (url) => {
      if (!url) return true
      const placeholders = ['placehold.co', 'placeholder.com', 'via.placeholder', '/avatars/bot1.png', 'gravatar.com/avatar/0']
      return placeholders.some(p => url.includes(p))
    }

    const getUserAvatar = (owner) => {
      const pic = owner.profile_picture
      if (!pic || isPlaceholderAvatar(pic)) return null
      if (pic.startsWith('http')) return pic
      return `https://api.peelo.io/public/${pic}`
    }

    // Returns a profile picture or a unique DiceBear robot avatar as fallback
    const getAvatarUrl = (owner) => {
      const real = getUserAvatar(owner)
      if (real) return real
      // Seed by _id for uniqueness, style = bottts (gender-neutral robots)
      const seed = encodeURIComponent(owner._id || owner.name || owner.email || 'user')
      return `https://api.dicebear.com/9.x/bottts/svg?seed=${seed}&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`
    }

    const handleAvatarError = (event, owner) => {
      // On error, fallback to dicebear
      const seed = encodeURIComponent(owner._id || owner.name || 'user')
      event.target.src = `https://api.dicebear.com/9.x/bottts/svg?seed=${seed}&backgroundColor=b6e3f4,c0aede,d1d4f9`
    }


    const updateVerificationStatus = async (account, newStatus) => {
        try {
            await AdminService.updateWhatsAppAccountStatus(account._id, newStatus)
            account.code_verification_status = newStatus
            showNotification(`Statut mis à jour: ${newStatus}`)
        } catch (e) {
            showNotification('Erreur mise à jour', 'error')
        }
    }

    const updateOwnerPlan = async (owner, newPlanSlug) => {
        if (owner.updatingPlan) return;

        // Special handling for Enterprise plan
        if (newPlanSlug === 'enterprise') {
            // Setup local state for enterprise input if not exists
            if (owner.showEnterprisePriceInput === undefined) {
                 // We can assign property dynamically but ideally we should initialize it. 
                 // Since we are inside a method and owners is a ref array of objects from API, 
                 // Vue 3 reactivity handles new properties if they are not deeply nested or if we use proper assignment.
                 // However, best practice is to handle UI state properly.
                 // Here we simply set a temporary state on the object.
            }
            owner.tempPlanSlug = newPlanSlug; // Store intent
            owner.showEnterprisePriceInput = true;
            owner.customEnterprisePrice = null;
            return; // Stop here, wait for manual confirmation
        }
        
        // Ensure UI state is reset if switching away
        owner.showEnterprisePriceInput = false;
        
        await processPlanUpdate(owner, newPlanSlug);
    }
    
    const confirmEnterprisePlan = async (owner) => {
         if (!owner.customEnterprisePrice || owner.customEnterprisePrice <= 0) {
             showNotification('Veuillez entrer un prix valide', 'error');
             return;
         }
         await processPlanUpdate(owner, 'enterprise', owner.customEnterprisePrice);
         owner.showEnterprisePriceInput = false;
    }

    const cancelEnterprisePlan = (owner) => {
        owner.showEnterprisePriceInput = false;
        owner.customEnterprisePrice = null;
        // Optionally revert select value visually if needed, but since it's v-bind :value="owner.plan", 
        // it should revert automatically on next render as we didn't change owner.plan yet.
        // However, the <select> element's internal value might have changed.
        // Force update key or similar might be needed if visual glitch occurs, but usually :value binding handles it.
        // Let's force a re-render/update of the select if needed by toggling a small state or just relying on Vue.
        
        // Actually, since @change triggered this, visual state of select IS 'enterprise'. 
        // But owner.plan is still OLD value. 
        // Vue binding :value="owner.plan" should force it back, but HTML select behavior can be sticky.
        // A simple way is to force a re-assignment of owner.plan to itself to trigger reactivity?
        const currentPlan = owner.plan;
        owner.plan = ''; 
        setTimeout(() => owner.plan = currentPlan, 0);
    }

    const processPlanUpdate = async (owner, planSlug, customPrice = null) => {
        try {
            owner.updatingPlan = true;
            const result = await AdminService.assignPlan(owner._id, planSlug, customPrice);
            
            if (result.success) {
                owner.plan = planSlug;
                owner.showEnterprisePriceInput = false; 
                showNotification(`Plan mis à jour pour ${owner.name}` + (customPrice ? ` ($${customPrice})` : ''));
            } else {
                showNotification(result.message || 'Erreur lors de la mise à jour du plan', 'error');
            }
        } catch (error) {
            consoleError('Error updating plan:', error);
            showNotification('Erreur lors de la mise à jour du plan', 'error');
        } finally {
            owner.updatingPlan = false;
        }
    }
    
    const changePage = (p) => {
        pagination.page = p
        loadOwners()
    }

    const goBack = () => router.push('/dashboard')

    // CREDITS METHODS
    const loadCreditsData = async () => {
        try {
            loadingCredits.value = true
            const response = await AdminService.getGlobalCreditsDashboard(creditsMonth.value)
            console.log('🔍 SERVER RESPONSE (CREDITS):', response) // DEBUG LOG
            
            // Fix: Check if response has success property or if it IS the data object
            const data = response.success ? response : (response.dashboard ? { success: true, dashboard: response.dashboard } : response)
            
            if (data && data.dashboard) {
                creditsData.value = data
                // Update form with current values
                if (data.dashboard.global_budget) {
                    budgetForm.budget_usd = data.dashboard.global_budget.initial_usd
                }
                if (data.dashboard.alert_thresholds) {
                    budgetForm.alert_thresholds = [...data.dashboard.alert_thresholds]
                }
            }
        } catch (e) {
            consoleError('Error loading credits:', e)
            showNotification('Erreur chargement crédits', 'error')
        } finally {
            loadingCredits.value = false
        }
    }

    const updateBudget = async () => {
        try {
            updatingBudget.value = true
            await AdminService.setGlobalCreditsBudget(budgetForm)
            showNotification('Budget mis à jour')
            loadCreditsData() // Reload
        } catch(e) {
            showNotification('Erreur update budget', 'error')
        } finally {
            updatingBudget.value = false
        }
    }

    const testWebhook = async () => {
        try {
            await AdminService.testGlobalCreditsWebhook()
            showNotification('Webhook testé (voir console)')
        } catch (e) {
            showNotification('Erreur test webhook', 'error')
        }
    }
    
    // FORMATTERS
    const formatCurrency = (val) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 4 }).format(val || 0)
    }

    const formatNumber = (val) => {
        return new Intl.NumberFormat('en-US').format(val || 0)
    }

    const getUsageColor = (percent) => {
        if (percent < 50) return '#10b981'
        if (percent < 80) return '#f59e0b'
        return '#ef4444'
    }

    // NEW FORMATTERS FOR V2 DESIGN
    const formatSimpleCurrency = (val) => {
        if (val === undefined || val === null) return '0.00'
        return parseFloat(val).toFixed(2)
    }

    const getBudgetStatusClass = (percent) => {
        if (percent < 50) return 'status-good'
        if (percent < 80) return 'status-warning'
        return 'status-danger'
    }

    const getBudgetStatusText = (percent) => {
        if (percent < 50) return `✓ ${(100 - percent).toFixed(0)}% disponible`
        if (percent < 80) return `⚠ ${(100 - percent).toFixed(0)}% restant`
        return `⚠ Attention: ${(100 - percent).toFixed(0)}% restant`
    }

    const getBudgetHealthClass = (percent) => {
        if (percent < 50) return 'health-good'
        if (percent < 80) return 'health-warning'
        return 'health-critical'
    }

    const getBudgetHealthLabel = (percent) => {
        if (percent < 50) return 'Excellent'
        if (percent < 80) return 'Correct'
        return 'Critique'
    }

    const getDonutColor = (percent) => {
        if (percent < 50) return '#ef4444' // red - high usage
        if (percent < 80) return '#f59e0b' // orange - medium usage
        return '#10b981' // green - low usage
    }

    const getDonutDasharray = (remainingPercent) => {
        const circumference = 100
        const filled = (remainingPercent / 100) * circumference
        return `${filled} ${circumference - filled}`
    }

    const getTokenPercent = (type) => {
        if (!creditsData.value?.dashboard?.tokens) return 0
        const total = creditsData.value.dashboard.tokens.total || 1
        if (type === 'input') {
            return (creditsData.value.dashboard.tokens.total_input / total) * 100
        }
        return (creditsData.value.dashboard.tokens.total_output / total) * 100
    }

    const getCostPercent = (type) => {
        if (!creditsData.value?.dashboard?.cost_breakdown) return 0
        const total = creditsData.value.dashboard.cost_breakdown.total_cost || 1
        if (type === 'input') {
            return (creditsData.value.dashboard.cost_breakdown.input_cost / total) * 100
        }
        return (creditsData.value.dashboard.cost_breakdown.output_cost / total) * 100
    }

    const copyToClipboard = async (text, type) => {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        showNotification(`${type} copié dans le presse-papier`, 'success');
      } catch (err) {
        consoleError('Failed to copy to clipboard:', err);
        showNotification('Impossible de copier le texte', 'error');
      }
    }

    const showDump = ref(false)
    const isDev = isDevelopment

    onMounted(() => {
        loadDashboardData()
    })

    const formatModels = (models) => {
        if (!models || !Array.isArray(models) || models.length === 0) return 'N/A'
        return models.map(m => m.replace('claude-', '').replace('gpt-', '').replace('deepseek-', '')).join(', ')
    }

    const getCreationDate = (owner) => {
        if (owner.createdAt) return owner.createdAt
        if (owner.created_at) return owner.created_at
        if (owner._id) {
            try {
                const timestamp = parseInt(owner._id.substring(0, 8), 16) * 1000
                return new Date(timestamp)
            } catch (e) {
                return null
            }
        }
        return null
    }

    const formatDate = (dateInput) => {
        if (!dateInput) return 'N/A'
        const date = new Date(dateInput)
        // Check if valid date
        if (isNaN(date.getTime())) return 'N/A'
        
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    const showCreditsDump = ref(false)

    // ===== Quotas IA (superadmin) =====
    const savePlanQuota = async (plan) => {
      try {
        plan.savingQuota = true
        await AdminService.updatePlanQuota(plan.slug, {
          ai_quota_moo: (plan.ai_quota_moo === '' || plan.ai_quota_moo == null) ? null : Number(plan.ai_quota_moo),
          ai_quota_griot: (plan.ai_quota_griot === '' || plan.ai_quota_griot == null) ? null : Number(plan.ai_quota_griot)
        })
        showNotification(`Quotas du plan ${plan.name} mis à jour`)
      } catch (e) {
        showNotification('Erreur quota plan', 'error')
      } finally {
        plan.savingQuota = false
      }
    }

    const saveOwnerAiQuota = async (owner) => {
      try {
        owner.savingAiQuota = true
        await AdminService.setOwnerAiQuota(owner._id, {
          ai_unlimited: !!owner.ai_unlimited,
          ai_quota_override: {
            moo: (owner.aiQuotaMoo === '' || owner.aiQuotaMoo == null) ? null : Number(owner.aiQuotaMoo),
            griot: (owner.aiQuotaGriot === '' || owner.aiQuotaGriot == null) ? null : Number(owner.aiQuotaGriot)
          }
        })
        showNotification(`Quota IA mis à jour pour ${owner.name}`)
      } catch (e) {
        showNotification('Erreur quota IA', 'error')
      } finally {
        owner.savingAiQuota = false
      }
    }

    const toggleOwnerAgents = async (owner) => {
      owner.showAgents = !owner.showAgents
      if (owner.showAgents && !owner.agents) {
        try {
          owner.loadingAgents = true
          const res = await AdminService.getOwnerAgents(owner._id)
          owner.agents = (res.agents || []).map(a => ({
            idbot: a.idbot,
            name: a.name,
            unlimited: !!(a.ai_quota && a.ai_quota.unlimited),
            moo: (a.ai_quota && a.ai_quota.moo) ? a.ai_quota.moo.month : '',
            griot: (a.ai_quota && a.ai_quota.griot) ? a.ai_quota.griot.month : ''
          }))
        } catch (e) {
          showNotification('Erreur chargement agents', 'error')
        } finally {
          owner.loadingAgents = false
        }
      }
    }

    const saveAgentAiQuota = async (owner, ag) => {
      try {
        ag.saving = true
        await AdminService.setAgentAiQuota(ag.idbot, {
          unlimited: !!ag.unlimited,
          moo: (ag.moo === '' || ag.moo == null) ? '' : Number(ag.moo),
          griot: (ag.griot === '' || ag.griot == null) ? '' : Number(ag.griot)
        })
        showNotification(`Quota agent mis à jour : ${ag.name}`)
      } catch (e) {
        showNotification('Erreur quota agent', 'error')
      } finally {
        ag.saving = false
      }
    }

    return {
        activeTab, loading, owners, filteredOwners, searchQuery, selectedFilter, pagination,
        globalStats, aiConfig, claudeModels, savingConfig, notification, plans,
        saveAiConfig, handleImageError, handleAvatarError, getInitials, loginAsUser, updateVerificationStatus, updateOwnerPlan, 
        confirmEnterprisePlan, cancelEnterprisePlan, changePage, goBack, copyToClipboard, getUserAvatar, getAvatarUrl,
        showDump, isDev,
        creditsData, loadingCredits, creditsMonth, budgetForm, updatingBudget, loadCreditsData, updateBudget, testWebhook,
        formatCurrency, formatNumber, getUsageColor, formatSimpleCurrency,
        getBudgetStatusClass, getBudgetStatusText, getBudgetHealthClass, getBudgetHealthLabel,
        getDonutColor, getDonutDasharray, getTokenPercent, getCostPercent,
        showCreditsDump, formatModels, formatDate, getCreationDate,
        savePlanQuota, saveOwnerAiQuota, toggleOwnerAgents, saveAgentAiQuota
    }
  }
}
</script>

<style scoped>
/* Plan Selector Styles */
.user-plan-selector {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap; /* Allow wrapping */
}

.user-date {
    font-size: 0.75rem;
    color: #6b7280;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

/* Enterprise Input Styles */
.enterprise-price-input {
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.5rem;
    background: #f0fdf4;
    border: 1px dashed #25D366;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.price-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.price-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #166534;
}

.price-input {
    padding: 0.25rem 0.5rem;
    border: 1px solid #bbf7d0;
    border-radius: 0.25rem;
    font-size: 0.85rem;
    width: 100%;
}

.price-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
}

.confirm-price-btn, .cancel-price-btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    border-radius: 0.25rem;
    cursor: pointer;
    border: none;
    font-weight: 500;
}

.confirm-price-btn {
    background: #25D366;
    color: white;
}
.confirm-price-btn:disabled {
    background: #86efac;
    cursor: not-allowed;
}

.cancel-price-btn {
    background: white;
    border: 1px solid #e5e7eb;
    color: #6b7280;
}

.plan-label {
    font-size: 0.8rem;
    color: #6b7280;
    font-weight: 500;
}

.plan-select {
    padding: 0.25rem 0.5rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.375rem;
    font-size: 0.85rem;
    color: #374151;
    background-color: white;
    cursor: pointer;
    min-width: 120px;
}

.plan-select:focus {
    outline: none;
    border-color: #25D366;
    box-shadow: 0 0 0 1px #25D366;
}

.plan-loading {
    opacity: 0.7;
    cursor: not-allowed;
}

.spinner-xs {
    width: 12px;
    height: 12px;
    border: 2px solid #e5e7eb;
    border-top-color: #25D366;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

/* --- MODERN USER HEADER STYLES --- */
.user-header-modern {
    padding: 1.5rem;
    background: white;
}

.uh-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
}

.uh-identity {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.uh-avatar {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    overflow: hidden;
    background: linear-gradient(135deg, #b6e3f4 0%, #c0aede 100%);
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
    border: 2px solid rgba(255,255,255,0.8);
}

.uh-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}


.uh-text {
    display: flex;
    flex-direction: column;
}

.uh-name {
    font-size: 1.1rem;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.3;
}

.uh-email {
    font-size: 0.9rem;
    color: #6b7280;
    margin: 0;
}

.icon-btn-modern {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 8px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.2s;
}

.icon-btn-modern:hover {
    border-color: #25D366;
    color: #25D366;
    background: #f0fdf4;
}

.uh-divider {
    height: 1px;
    background: #f3f4f6;
    margin-bottom: 1.5rem;
}

.uh-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid #f0f2f5;
    border-radius: 10px;
    overflow: hidden;
}

/* Each row in the 2-column stat card */
.uh-stat-row {
    display: grid;
    grid-template-columns: 1fr 1px 1fr;
    align-items: stretch;
    padding: 0;
}

.uh-stat-row + .uh-stat-row {
    border-top: 1px solid #f0f2f5;
}

.uh-stat-item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: 0.85rem 1rem;
    min-width: 0; /* prevent overflow */
}

/* Vertical divider between the two stat columns */
.uh-stat-divider {
    width: 1px;
    background: #f0f2f5;
    align-self: stretch;
}

.uh-label {
    font-size: 0.7rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
}

.uh-value {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.uh-value.clickable {
    cursor: pointer;
    transition: color 0.15s;
}

.uh-value.clickable:hover {
    color: #25D366;
}

.uh-code {
    font-family: 'SFMono-Regular', Consolas, monospace;
    background: #f3f4f6;
    padding: 0.1rem 0.4rem;
    border-radius: 4px;
    font-size: 0.82rem;
    color: #4b5563;
    font-weight: 600;
}

.uh-date {
    color: #6b7280;
    font-weight: 500;
    font-size: 0.85rem;
    gap: 0.35rem;
}

.uh-date svg {
    color: #9ca3af;
    flex-shrink: 0;
}

.copy-icon {
    opacity: 0;
    transition: opacity 0.2s;
    color: #9ca3af;
    flex-shrink: 0;
}

.uh-value.clickable:hover .copy-icon {
    opacity: 1;
}

.text-muted {
    color: #9ca3af;
    font-style: italic;
    font-weight: 400;
}


/* Modern Select */
.plan-selector-wrapper {
    position: relative;
    width: 100%;
}

.modern-select {
    width: 100%;
    padding: 0.4rem 2rem 0.4rem 0.75rem; /* Space for spinner if needed, layout mainly handled by grid */
    font-size: 0.9rem;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background-color: #f9fafb;
    color: #111827;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.5rem center;
    background-size: 1em;
}

.modern-select:hover {
    border-color: #d1d5db;
    background-color: white;
}

.modern-select:focus {
    outline: none;
    border-color: #25D366;
    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.spinner-mini {
    width: 12px;
    height: 12px;
    border: 2px solid #e5e7eb;
    border-top-color: #25D366;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: absolute;
    right: 2.5rem;
    top: 50%;
    transform: translateY(-50%);
}

/* Enterprise Config Panel */
.enterprise-config-panel {
    margin-top: 1.5rem;
    padding: 1rem;
    background: #f0fdf4;
    border: 1px dashed #25D366;
    border-radius: 8px;
    animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.ecp-header {
    margin-bottom: 0.75rem;
}

.ecp-title {
    font-size: 0.8rem;
    font-weight: 700;
    color: #166534;
    text-transform: uppercase;
}

.ecp-body {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
}

.ecp-input-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.ecp-input-group label {
    font-size: 0.8rem;
    color: #15803d;
    font-weight: 500;
}

.ecp-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #bbf7d0;
    border-radius: 6px;
    font-size: 0.95rem;
    outline: none;
}

.ecp-input:focus {
    border-color: #25D366;
    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.2);
}

.ecp-actions {
    display: flex;
    gap: 0.5rem;
}

.ecp-btn {
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.15s;
}

.ecp-btn.confirm {
    background: #16a34a;
    color: white;
}

.ecp-btn.confirm:hover:not(:disabled) {
    background: #15803d;
}

.ecp-btn.confirm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.ecp-btn.cancel {
    background: white;
    color: #4b5563;
    border: 1px solid #d1d5db;
}

.ecp-btn.cancel:hover {
    background: #f3f4f6;
}



.admin-dashboard {
  min-height: 100vh;
  background: #f3f4f6;
  padding-bottom: 2rem;
}

/* HEADER ACTIONS & STATS */
.header-actions-wrapper {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.back-btn-modern {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 24px;
  background: #143028; /* Peelo Dark Green */
  color: #DAFFD1; /* Peelo Light Green */
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(20, 48, 40, 0.2);
}

.back-btn-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(20, 48, 40, 0.3);
  filter: brightness(1.1);
}

.back-btn-modern svg {
  color: #DAFFD1;
}

.header-stats-modern {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 28px;
  border-radius: 16px;
  border: 1px solid rgba(0,0,0,0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  width: fit-content;
}

.content-stats {
  margin-bottom: 2rem;
}

.mini-stat-modern {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

.ms-divider {
  width: 1px;
  height: 32px;
  background: rgba(0,0,0,0.08);
  margin: 0 24px;
}

.ms-label {
  font-size: 11px;
  text-transform: uppercase;
  color: #6F767E;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.ms-value {
  font-size: 22px;
  font-weight: 800;
  color: #1A1D1F;
  letter-spacing: -0.02em;
}

.dashboard-content { max-width: 1200px; margin: 2rem 0; padding: 0 1rem; }

/* TABS */
.tabs-container { display: flex; gap: 0.5rem; margin-bottom: 1.5rem; border-bottom: 1px solid #e5e7eb; padding-bottom: 1px; }
.tab-btn {
    display: flex; align-items: center; gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    color: #6b7280;
    font-weight: 500;
    cursor: pointer;
    font-size: 0.95rem;
    transition: all 0.2s;
}
.tab-btn:hover { color: #111827; }
.tab-btn.active { color: #25D366; border-bottom-color: #25D366; }

/* SECTIONS */
.tab-panel { 
  background: white; 
  border-radius: 1rem; 
  padding: 1.5rem; 
  box-shadow: 0 1px 3px rgba(0,0,0,0.1); 
}

/* Override for Users Section to be Glass/Transparent */
.tab-panel.users-section {
  background: transparent;
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.section-title { font-size: 1.25rem; font-weight: 600; color: #111827; margin-bottom: 1.5rem; padding-left: 1rem; }
.section-header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; flex-wrap: wrap; gap: 1rem; padding: 0 1rem; }

/* AI CONFIG STYLES */
.ai-config-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05); 
}

/* Header */
.config-header-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  color: #166534;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-title.no-margin {
  margin-bottom: 0.25rem;
  padding-left: 0;
  font-size: 1.25rem;
}

.section-subtitle {
  color: #6b7280;
  font-size: 0.95rem;
  margin: 0;
}

/* Card & Grid */
.config-card {
  position: relative; /* Context for potential absolute children */
}

.config-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-bottom: 1rem;
}

.config-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.column-title {
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #9ca3af;
  letter-spacing: 0.05em;
  margin: 0 0 0.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed #e5e7eb;
}

/* Config Items */
.config-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.config-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.95rem;
}

.label-icon {
  color: #059669; /* Slightly darker green for icons */
}

.input-wrapper, .select-wrapper {
  position: relative;
  transition: all 0.2s;
}

.config-input, .config-select {
  width: 100%;
  padding: 0.875rem 1rem;
  background: #f9fafb;
  border: 1px solid transparent; /* Cleaner look */
  border-radius: 12px;
  font-size: 0.95rem;
  color: #111827;
  transition: all 0.2s ease;
  font-family: inherit;
}

.config-input:hover, .config-select:hover {
  background: #f3f4f6;
}

.config-input:focus, .config-select:focus {
  background: white;
  border-color: #25D366;
  box-shadow: 0 0 0 4px rgba(37, 211, 102, 0.1);
  outline: none;
}

.select-arrow {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
}

.input-unit {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.85rem;
  pointer-events: none;
  font-weight: 500;
}

.config-help {
  font-size: 0.85rem;
  color: #6b7280;
  margin: 0.25rem 0 0 0;
  line-height: 1.4;
}

/* Info Box */
.config-info-box {
    background: #eff6ff;
    border-radius: 12px;
    padding: 1rem;
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
    margin-top: auto; /* Push to bottom of column */
}

.info-icon {
    color: #3b82f6;
    flex-shrink: 0;
    margin-top: 0.1rem;
}

.config-info-box p {
    font-size: 0.85rem;
    color: #1e40af;
    line-height: 1.4;
    margin: 0;
}

/* Footer & Button */
.config-footer {
  margin-top: 3rem;
  display: flex;
  justify-content: flex-end;
  padding-top: 1.5rem;
  border-top: 1px solid #f3f4f6;
}

.save-config-btn {
  background: #111827;
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.2s;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.save-config-btn:hover:not(:disabled) {
  background: black;
  transform: translateY(-1px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.save-config-btn:active:not(:disabled) {
  transform: translateY(0);
}

.save-config-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* ===== Quotas IA — base par formule ===== */
.quota-base-card { margin-bottom: 1.25rem; }
.column-title.no-border { border-bottom: none; padding-bottom: 0; margin-bottom: 0.35rem; }
.quota-card-head { margin-bottom: 0.75rem; }
.quota-card-head .config-help code {
  background: #f3f4f6; padding: 0.05rem 0.35rem; border-radius: 5px;
  font-family: ui-monospace, monospace; font-size: 0.8em; color: #374151;
}
.plan-quota-list { display: flex; flex-direction: column; }
.plan-quota-row {
  display: flex; align-items: flex-end; gap: 1.25rem; flex-wrap: wrap;
  padding: 0.9rem 0; border-bottom: 1px solid #f3f4f6;
}
.plan-quota-row:last-child { border-bottom: none; padding-bottom: 0; }
.pq-name { display: flex; flex-direction: column; min-width: 150px; gap: 0.15rem; }
.pq-plan { font-weight: 700; color: #111827; font-size: 0.95rem; }
.pq-price { font-size: 0.8rem; color: #9ca3af; font-weight: 500; }
.pq-field { display: flex; flex-direction: column; gap: 0.4rem; }
.pq-label { font-size: 0.8rem; font-weight: 600; color: #6b7280; }
.pq-input { width: 150px; padding: 0.6rem 1rem; }
.pq-field .input-unit { font-size: 0.75rem; }
.pq-save {
  margin-left: auto; background: #111827; color: #fff; border: none;
  padding: 0.65rem 1.4rem; border-radius: 12px; font-weight: 600; font-size: 0.85rem;
  cursor: pointer; transition: all 0.2s; display: flex; align-items: center; gap: 0.4rem;
}
.pq-save:hover:not(:disabled) { background: #000; transform: translateY(-1px); }
.pq-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* ===== Quota IA par compte (carte owner) ===== */
.aiq-panel {
  margin-top: 1rem; padding: 1rem 1.25rem; border: 1px solid #eef0f2;
  border-radius: 14px; background: #fafbfc;
}
.aiq-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.85rem; }
.aiq-title { display: flex; align-items: center; gap: 0.45rem; font-weight: 700; font-size: 0.9rem; color: #111827; }
.aiq-title svg { color: #059669; }
.aiq-switch { display: flex; align-items: center; gap: 0.4rem; font-size: 0.82rem; color: #374151; cursor: pointer; user-select: none; }
.aiq-fields { display: flex; gap: 0.85rem; align-items: flex-end; flex-wrap: wrap; }
.aiq-field { display: flex; flex-direction: column; gap: 0.3rem; }
.aiq-field label { font-size: 0.75rem; font-weight: 600; color: #6b7280; }
.aiq-input {
  width: 110px; padding: 0.55rem 0.85rem; background: #fff; border: 1px solid #e5e7eb;
  border-radius: 10px; font-size: 0.85rem; color: #111827; transition: all 0.2s; font-family: inherit;
}
.aiq-input.sm { width: 84px; }
.aiq-input:focus { outline: none; border-color: #25D366; box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.12); }
.aiq-save {
  background: #111827; color: #fff; border: none; padding: 0.55rem 1.1rem; border-radius: 10px;
  font-weight: 600; font-size: 0.82rem; cursor: pointer; transition: all 0.2s;
}
.aiq-save:hover:not(:disabled) { background: #000; }
.aiq-save.sm { padding: 0.45rem 0.85rem; font-size: 0.78rem; }
.aiq-save:disabled { opacity: 0.6; cursor: not-allowed; }
.aiq-agents { margin-top: 0.9rem; padding-top: 0.8rem; border-top: 1px dashed #e5e7eb; }
.aiq-agents-toggle { background: none; border: none; color: #059669; font-size: 0.82rem; font-weight: 600; cursor: pointer; padding: 0; }
.aiq-agents-list { margin-top: 0.5rem; }
.aiq-muted { font-size: 0.8rem; color: #9ca3af; padding: 0.4rem 0; }
.aiq-agent-row { display: flex; gap: 0.5rem; align-items: center; flex-wrap: wrap; padding: 0.4rem 0; }
.aiq-agent-name { font-size: 0.82rem; color: #374151; min-width: 110px; font-weight: 500; }
.aiq-agent-unl { display: flex; align-items: center; gap: 0.25rem; font-size: 0.78rem; color: #374151; }

/* Spinner */
.spinner-sm {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .config-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

/* NOTIFICATION TOAST */
.notification {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  color: white;
  font-weight: 500;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 1000;
  animation: slideIn 0.3s ease-out;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 400px;
}

.notification.success {
  background-color: #059669; /* Green */
  border-left: 4px solid #34d399;
}

.notification.error {
  background-color: #dc2626; /* Red */
  border-left: 4px solid #f87171;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* DASHBOARD CONTROLS */
.dashboard-controls {
  margin-bottom: 2rem;
}

.controls-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.search-section {
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
}

.search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  outline: none;
  transition: all 0.2s;
  background: white;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.search-input:focus {
  border-color: #25D366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.filters-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.filter-tabs {
  display: flex;
  gap: 0.5rem;
  background: #e5e7eb;
  padding: 0.25rem;
  border-radius: 0.5rem;
}

.filter-tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-tab.active {
  background: white;
  color: #111827;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.tab-count {
  background: #f3f4f6;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.filter-tab.active .tab-count {
  background: #f0fdf4;
  color: #166534;
}

.items-per-page {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.limit-select {
  padding: 0.35rem 2rem 0.35rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: white;
  color: #374151;
  font-size: 0.875rem;
  cursor: pointer;
}

/* USERS GRID */
.users-container {
    width: 100%;
}

.users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.user-card {
  background: white;
  border-radius: 1rem;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
}

.user-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-color: #d1d5db;
}

/* USER HEADER */
.user-header {
  padding: 1.25rem;
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid #f3f4f6;
  position: relative;
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
}

.user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.user-name {
  font-weight: 600;
  color: #111827;
  font-size: 1rem;
  margin: 0 0 0.25rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0 0 0.5rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}



.user-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    font-size: 0.8rem;
    color: #6b7280;
    width: 100%;
}

.user-id {
  font-family: monospace;
  background: #f9fafb;
  padding: 0.1rem 0.4rem;
  border-radius: 0.25rem;
  border: 1px solid #e5e7eb;
}

.user-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.action-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  background: white;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  border-color: #25D366;
  color: #25D366;
  background: #f0fdf4;
}

/* WHATSAPP SECTION */
.whatsapp-section {
  padding: 1rem;
  background: #f9fafb;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
}

.whatsapp-icon {
  color: #25D366;
}

.section-title h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.count-badge {
  background: #e5e7eb;
  color: #4b5563;
  font-size: 0.75rem;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  font-weight: 600;
}

/* EMPTY STATE */
.empty-whatsapp {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  color: #9ca3af;
  border: 1px dashed #e5e7eb;
  border-radius: 0.75rem;
  flex: 1;
}

.empty-whatsapp-icon {
  margin-bottom: 0.5rem;
  opacity: 0.5;
}

.empty-whatsapp p {
  font-size: 0.875rem;
  margin: 0;
}

/* WHATSAPP CARDS */
.whatsapp-accounts-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.whatsapp-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 0.75rem;
  transition: all 0.2s;
}

.whatsapp-card:hover {
  border-color: #25D366;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.whatsapp-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #f3f4f6;
}

.phone-number {
  font-weight: 600;
  color: #111827;
  font-family: monospace;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
}

.business-name {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 0.25rem;
  margin-left: 1.4rem;
}

.status-dropdown {
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  outline: none;
}

.status-dropdown.verified { background: #f0fdf4; color: #166534; border-color: #bbf7d0; }
.status-dropdown.pending { background: #fefce8; color: #a16207; border-color: #fef08a; }
.status-dropdown.expired { background: #fef2f2; color: #991b1b; border-color: #fecaca; }

.whatsapp-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.account-metrics {
  display: flex;
  gap: 1rem;
}

.metric {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.metric-label {
  font-size: 0.7rem;
  color: #9ca3af;
  text-transform: uppercase;
}

.metric-value {
  font-size: 0.8rem;
  font-weight: 500;
  color: #4b5563;
}

.quality-green { color: #166534; }
.quality-yellow { color: #a16207; }
.quality-red { color: #991b1b; }

.account-ids {
  display: flex;
  flex-wrap: wrap; 
  gap: 1rem;
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  border-top: 1px dashed #f3f4f6;
}

.bot-id-row {
    width: 100%;
    margin-top: 4px;
}

.id-item {
  font-size: 0.7rem;
  color: #9ca3af;
  display: flex;
  gap: 0.25rem;
}

.id-value {
  font-family: monospace;
  color: #6b7280;
}

/* PAGINATION */
.pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1rem;
}

.load-more-btn {
    padding: 0.5rem 1rem;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    color: #4b5563;
    cursor: pointer;
    transition: all 0.2s;
}

.load-more-btn:hover:not(:disabled) {
    border-color: #25D366;
    color: #25D366;
}

.load-more-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
}

.pagination-info {
    font-size: 0.875rem;
    color: #6b7280;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .users-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .users-grid {
    grid-template-columns: 1fr;
  }
  
  .controls-container {
      flex-direction: column;
  }
  
  .filters-section {
      flex-direction: column;
      align-items: stretch;
  }
  
  .filter-tabs {
      overflow-x: auto;
      padding-bottom: 0.5rem;
  }
  
  .items-per-page {
      justify-content: space-between;
  }
}

.page-info {
  font-size: 0.9rem;
  color: #6b7280;
}

/* Loading & Empty States */
.loading-container, .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #6b7280;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.loader {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-radius: 50%;
  border-top-color: #111827;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
.notification.error { background: #EF4444; }

.pagination { display: flex; justify-content: center; align-items: center; gap: 1rem; margin-top: 1.5rem; }
.page-btn { padding: 0.25rem 0.75rem; border: 1px solid #e5e7eb; border-radius: 0.25rem; background: white; cursor: pointer; }
.page-info { font-size: 0.875rem; color: #6b7280; }

.clickable-text {
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  padding: 2px 4px;
  border-radius: 4px;
}

.clickable-text:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.user-id.clickable-text:hover {
  text-decoration: underline;
}

.user-tel.clickable-text:hover {
  text-decoration: underline;
}

/* CREDITS DASHBOARD STYLES */
.credits-dashboard {
    margin-top: 1rem;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
}

.stat-card {
    background: #f9fafb;
    border-radius: 12px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border: 1px solid #e5e7eb;
}

.stat-card.primary { border-left: 4px solid #3b82f6; }
.stat-card.warning { border-left: 4px solid #f59e0b; }
.stat-card.success { border-left: 4px solid #10b981; }
.stat-card.info { border-left: 4px solid #8b5cf6; }

.stat-label {
    font-size: 0.85rem;
    color: #6b7280;
    text-transform: uppercase;
    font-weight: 600;
}

.stat-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
}

.stat-meta, .stat-sub {
    font-size: 0.75rem;
    color: #9ca3af;
}

.progress-bar {
    height: 6px;
    background: #e5e7eb;
    border-radius: 3px;
    margin: 0.5rem 0;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    transition: width 0.3s ease;
}

.dashboard-split {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 2rem;
}

@media (max-width: 1024px) {
    .dashboard-split {
        grid-template-columns: 1fr;
    }
}

.card-box {
    background: #f9fafb;
    border-radius: 12px;
    padding: 1.5rem;
    border: 1px solid #e5e7eb;
}

.card-box.full-height {
    height: 100%;
}

.card-box h3 {
    margin-top: 0;
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
    color: #374151;
    border-bottom: 1px dashed #e5e7eb;
    padding-bottom: 0.5rem;
}

.breakdown-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.breakdown-item {
    display: flex;
    justify-content: space-between;
    font-size: 0.95rem;
    color: #4b5563;
}

.breakdown-item.total {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #e5e7eb;
    font-weight: 700;
    color: #111827;
}

.budget-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    color: #374151;
    font-weight: 500;
}

.thresholds-inputs {
    display: flex;
    gap: 0.5rem;
}

.config-input.small {
    padding: 0.5rem;
    text-align: center;
}

.actions-row {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.small-btn {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    margin-top: 0;
}

.text-btn {
    border: none;
    background: none;
    text-decoration: underline;
    font-size: 0.85rem;
    width: auto;
    height: auto;
}

/* CONSUMERS LIST */
.consumers-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.consumer-header {
    display: grid;
    grid-template-columns: 50px 1fr 100px 60px;
    padding: 0.5rem;
    font-size: 0.8rem;
    color: #9ca3af;
    font-weight: 600;
    text-transform: uppercase;
}

.consumer-header.extended {
    grid-template-columns: 40px 1fr 60px 80px 80px 50px;
}

.consumer-row {
    display: grid;
    grid-template-columns: 50px 1fr 100px 60px;
    padding: 0.75rem 0.5rem;
    background: white;
    border-radius: 8px;
    align-items: center;
    border: 1px solid #f3f4f6;
    font-size: 0.9rem;
}

.consumer-row.extended {
    grid-template-columns: 40px 1fr 60px 80px 80px 50px;
}

.consumer-row:hover {
    border-color: #d1d5db;
}

.rank {
    font-weight: 700;
    color: #9ca3af;
}

.agent-info {
    display: flex;
    flex-direction: column;
}

.agent-name {
    font-weight: 600;
    color: #111827;
}

.agent-id {
    font-size: 0.75rem;
    color: #9ca3af;
    font-family: monospace;
}

.cost {
    font-family: monospace;
    font-weight: 600;
    color: #374151;
}

.percent {
    font-size: 0.85rem;
    color: #6b7280;
}

.text-right {
    text-align: right;
}

.empty-list {
    padding: 2rem;
    text-align: center;
    color: #9ca3af;
    font-style: italic;
}

/* ====================================================================
   CREDITS MONITORING V2 - MODERN DESIGN
   ==================================================================== */

.credits-section-v2 {
    background: #fafafa;
    padding: 0;
}

.credits-top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    background: white;
    border-bottom: 1px solid #e5e7eb;
    margin: -1.5rem -1.5rem 0;
}

.credits-greeting {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.greeting-emoji {
    font-size: 2rem;
}

.credits-greeting h2 {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
    color: #111827;
}

.credits-greeting p {
    margin: 0.25rem 0 0;
    font-size: 0.9rem;
    color: #6b7280;
}

.credits-controls {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.month-picker {
    padding: 0.6rem 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    font-size: 0.9rem;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
}

.month-picker:hover {
    border-color: #d1d5db;
}

.refresh-btn {
    width: 42px;
    height: 42px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    color: #6b7280;
}

.refresh-btn:hover {
    border-color: #d1d5db;
    color: #111827;
}

.credits-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5rem 2rem;
    color: #6b7280;
}

.credits-loader {
    width: 40px;
    height: 40px;
    border: 3px solid #e5e7eb;
    border-radius: 50%;
    border-top-color: #10b981;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
}

.credits-content-v2 {
    padding: 2rem;
}

/* Hero Section */
.credits-hero {
    background: linear-gradient(135deg, #fefce8 0%, #fef9c3 100%);
    border: 1px solid #fde047;
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}

.hero-main {
    text-align: left;
}

.hero-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #854d0e;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.hero-amount {
    font-size: 3.5rem;
    font-weight: 800;
    color: #1f2937;
    margin: 0.5rem 0;
    line-height: 1;
}

.hero-amount .currency {
    font-size: 2rem;
    font-weight: 600;
    vertical-align: super;
    margin-right: 0.25rem;
}

.hero-comparison {
    font-size: 0.95rem;
    color: #6b7280;
}

.hero-comparison .status-good {
    color: #10b981;
    font-weight: 600;
}

.hero-comparison .status-warning {
    color: #f59e0b;
    font-weight: 600;
}

.hero-comparison .status-danger {
    color: #ef4444;
    font-weight: 600;
}

/* Stats Cards Row */
.credits-stats-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin-bottom: 2rem;
}

@media (max-width: 900px) {
    .credits-stats-row {
        grid-template-columns: 1fr;
    }
}

.credit-stat-card {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 1.25rem 1.5rem;
    transition: all 0.2s;
}

.credit-stat-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.csc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}

.csc-label {
    font-size: 0.85rem;
    color: #6b7280;
    font-weight: 500;
}

.csc-icon {
    font-size: 1.2rem;
}

.csc-icon.consumed { color: #ef4444; }
.csc-icon.tokens { color: #8b5cf6; }
.csc-icon.requests { color: #3b82f6; }

.csc-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.75rem;
}

.csc-bar {
    height: 8px;
    background: #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 0.5rem;
}

.csc-bar.dual {
    display: flex;
}

.csc-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.5s ease;
}

.csc-bar-fill.consumed { background: linear-gradient(90deg, #fecaca, #ef4444); }
.csc-bar-fill.input { background: #a78bfa; }
.csc-bar-fill.output { background: #c4b5fd; }

.csc-footer {
    font-size: 0.8rem;
    color: #9ca3af;
    display: flex;
    gap: 1rem;
}

.csc-meta {
    font-size: 0.8rem;
    color: #9ca3af;
}

.token-legend {
    font-size: 0.75rem;
}
.token-legend.input { color: #7c3aed; }
.token-legend.output { color: #a78bfa; }

/* Main Dashboard Grid */
.credits-main-grid {
    display: grid;
    grid-template-columns: 380px 1fr;
    gap: 2rem;
}

@media (max-width: 1100px) {
    .credits-main-grid {
        grid-template-columns: 1fr;
    }
}

.credits-col-left {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.credits-col-right {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Health Card with Donut */
.health-card {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 1.5rem;
}

.health-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.health-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #374151;
}

.health-badge {
    padding: 0.35rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
}

.health-badge.health-good {
    background: #dcfce7;
    color: #166534;
}

.health-badge.health-warning {
    background: #fef3c7;
    color: #a16207;
}

.health-badge.health-critical {
    background: #fee2e2;
    color: #991b1b;
}

.health-content {
    display: flex;
    gap: 2rem;
    align-items: center;
}

.donut-container {
    position: relative;
    width: 130px;
    height: 130px;
    flex-shrink: 0;
}

.donut-chart {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
}

.donut-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.donut-percent {
    display: block;
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
}

.donut-label {
    display: block;
    font-size: 0.7rem;
    color: #9ca3af;
    text-transform: uppercase;
}

.health-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.health-detail-row {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
}

.hdr-label {
    color: #6b7280;
}

.hdr-value {
    font-weight: 600;
    color: #111827;
}

.hdr-value.consumed { color: #ef4444; }
.hdr-value.remaining { color: #10b981; }

/* Breakdown Card */
.breakdown-card {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 1.5rem;
}

.breakdown-card h3 {
    margin: 0 0 1.25rem;
    font-size: 1rem;
    font-weight: 600;
    color: #374151;
}

.breakdown-bars {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.bb-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.bb-row {
    display: flex;
    justify-content: space-between;
}

.bb-label {
    font-size: 0.85rem;
    color: #6b7280;
}

.bb-value {
    font-size: 0.85rem;
    font-weight: 600;
    color: #111827;
}

.bb-bar {
    height: 10px;
    background: #f3f4f6;
    border-radius: 5px;
    overflow: hidden;
}

.bb-fill {
    height: 100%;
    border-radius: 5px;
    transition: width 0.5s ease;
}

.bb-fill.input { background: linear-gradient(90deg, #86efac, #22c55e); }
.bb-fill.output { background: linear-gradient(90deg, #c4b5fd, #8b5cf6); }

.breakdown-total {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px dashed #e5e7eb;
    font-weight: 600;
    color: #111827;
}

.bt-value {
    font-size: 1.1rem;
}

/* Config Card V2 */
.config-card-v2 {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 1.5rem;
}

.config-card-v2 h3 {
    margin: 0 0 1.25rem;
    font-size: 1rem;
    font-weight: 600;
    color: #374151;
}

.config-form-v2 {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.cfg-group label {
    display: block;
    font-size: 0.85rem;
    color: #6b7280;
    margin-bottom: 0.5rem;
}

.cfg-input-wrapper {
    display: flex;
    align-items: center;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
}

.cfg-prefix {
    padding: 0.6rem 0.75rem;
    background: #f3f4f6;
    color: #6b7280;
    font-weight: 600;
    border-right: 1px solid #e5e7eb;
}

.cfg-input {
    flex: 1;
    padding: 0.6rem 0.75rem;
    border: none;
    background: transparent;
    font-size: 1rem;
    outline: none;
}

.cfg-thresholds {
    display: flex;
    gap: 0.75rem;
}

.cfg-threshold {
    display: flex;
    align-items: center;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
}

.cfg-threshold-input {
    width: 50px;
    padding: 0.5rem;
    border: none;
    background: transparent;
    text-align: center;
    font-size: 0.9rem;
    outline: none;
}

.cfg-threshold-suffix {
    padding-right: 0.5rem;
    color: #9ca3af;
    font-size: 0.85rem;
}

.cfg-actions {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.5rem;
}

.cfg-btn {
    padding: 0.6rem 1.25rem;
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
}

.cfg-btn.primary {
    background: #111827;
    color: white;
}

.cfg-btn.primary:hover {
    background: #1f2937;
}

.cfg-btn.primary:disabled {
    background: #d1d5db;
    cursor: not-allowed;
}

.cfg-btn.secondary {
    background: white;
    border: 1px solid #e5e7eb;
    color: #6b7280;
}

.cfg-btn.secondary:hover {
    border-color: #d1d5db;
    color: #374151;
}

/* Agents Card */
.agents-card {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 1.5rem;
    min-height: 400px;
}

.agents-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.agents-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #374151;
}

.agents-count {
    font-size: 0.8rem;
    color: #9ca3af;
    background: #f3f4f6;
    padding: 0.35rem 0.75rem;
    border-radius: 20px;
}

.agents-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 2rem;
    text-align: center;
}

.ae-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.agents-empty p {
    margin: 0;
    font-size: 1rem;
    color: #6b7280;
}

.ae-hint {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    color: #9ca3af;
}

.agents-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.agent-item {
    display: grid;
    grid-template-columns: 40px 1fr auto auto;
    gap: 1rem;
    align-items: center;
    padding: 1rem;
    background: #fafafa;
    border-radius: 10px;
    transition: all 0.2s;
}

.agent-item:hover {
    background: #f3f4f6;
}

.ai-rank {
    font-weight: 700;
    color: #9ca3af;
    font-size: 0.9rem;
}

.ai-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.ai-name {
    font-weight: 600;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ai-id {
    font-size: 0.75rem;
    color: #9ca3af;
    font-family: monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ai-stats {
    display: flex;
    gap: 1.5rem;
}

.ai-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ais-value {
    font-weight: 600;
    color: #111827;
    font-size: 0.9rem;
}

.ais-label {
    font-size: 0.7rem;
    color: #9ca3af;
    text-transform: uppercase;
}

.ai-cost {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
    min-width: 90px;
}

.aic-value {
    font-weight: 700;
    color: #111827;
    font-size: 0.95rem;
}

.aic-bar {
    width: 60px;
    height: 4px;
    background: #e5e7eb;
    border-radius: 2px;
    overflow: hidden;
}

.aic-fill {
    height: 100%;
    background: linear-gradient(90deg, #a78bfa, #8b5cf6);
    border-radius: 2px;
}

.aic-percent {
    font-size: 0.7rem;
    color: #9ca3af;
}

/* Alerts Card */
.alerts-card {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 14px;
    padding: 1.5rem;
}

.alerts-card h3 {
    margin: 0 0 1rem;
    font-size: 1rem;
    font-weight: 600;
    color: #991b1b;
}

.alerts-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.alert-item {
    padding: 0.75rem 1rem;
    background: white;
    border-radius: 8px;
    font-size: 0.9rem;
    color: #dc2626;
}

/* New Agent List Table Style */
.agent-list-header {
    display: grid;
    grid-template-columns: 40px 1fr 120px 80px 120px 80px;
    padding: 0.75rem 1rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    border-bottom: 1px solid #e5e7eb;
}

.agent-item-row {
    display: grid;
    grid-template-columns: 40px 1fr 120px 80px 120px 80px;
    padding: 1rem;
    align-items: center;
    border-bottom: 1px solid #f3f4f6;
    transition: background 0.2s;
}

.agent-item-row:last-child {
    border-bottom: none;
}

.agent-item-row:hover {
    background: #f9fafb;
}

.ai-info-cell {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-right: 1rem;
}

.ai-model-cell {
    display: flex;
    align-items: center;
}

.model-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    background: #e0e7ff;
    color: #4338ca;
    font-size: 0.7rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.ai-stat-cell {
    font-size: 0.9rem;
    color: #374151;
    font-weight: 500;
}

.sub-stat {
    font-size: 0.75rem;
    color: #9ca3af;
    font-weight: 400;
}

.ai-cost-cell {
    font-weight: 700;
    color: #111827;
}

.refresh-btn.active {
    background: #111827;
    color: white;
    border-color: #111827;
}

/* Mobile responsive adjustment for very small screens only */
@media (max-width: 640px) {
    .agent-list-header, .agent-item-row {
        grid-template-columns: 40px 1fr 70px 70px; /* 4 cols */
        gap: 0.5rem;
    }
    
    /* Hide Model (3) and Requests (4) to fit */
    .agent-list-header > span:nth-child(3),
    .agent-list-header > span:nth-child(4),
    .ai-model-cell,
    .agent-item-row > .ai-stat-cell:nth-child(4)
    {
        display: none;
    }
}
</style>
